import { FC } from "react";

import { FocusArea } from "../models/focus-area-model";

import { FocusAreaView } from "./focus-area-view";
import { FocusAreaViewEmpty } from "./focus-area-view-empty";

interface FocusAreaViewOptionalProps {
  focusArea?: FocusArea | null;
  logoOnly?: boolean;
  canWrapLabel?: boolean;
  className?: string;
}

export const FocusAreaViewOptional: FC<FocusAreaViewOptionalProps> = ({ focusArea, ...props }) => {
  if (!focusArea) {
    return <FocusAreaViewEmpty {...props} />;
  }

  return <FocusAreaView focusArea={focusArea} {...props} />;
};
